import { yupResolver } from "@hookform/resolvers/yup"
import {
  Button,
  LoadingOverlay,
  Modal,
  Select,
  Switch,
  Textarea,
  TextInput,
} from "@mantine/core"
import { DateInput } from "@mantine/dates"
import {
  IconCalendar,
  IconDeviceFloppy,
  IconEdit,
  IconHomePlus,
  IconTrash,
} from "@tabler/icons-react"
import { useEffect, useState } from "react"
import { Controller, useForm } from "react-hook-form"
import { useParams } from "react-router-dom"
import * as yup from "yup"
import { CollectionQuery } from "../../../models/collection.model"
import { RentIncrease } from "../../../models/rent-increase.model"
import Confirmation from "../../../shared/component/confirmation/action-confirmation"
import EmptyIcon from "../../../shared/component/empty-icon/empty-icon"
import { Pagination } from "../../../shared/component/pagination/pagination"
import { dateFormat } from "../../../shared/utility/date-format/date-format"

import { useDisclosure } from "@mantine/hooks"
import dayjs from "dayjs"
import { motion } from "framer-motion"
import { t } from "i18next"
import { useCurrentUser } from "../../../shared/hooks/current-user.hook"
import { useCreateRentIncreaseMutation, useDeleteRentIncreaseMutation, useLazyGetRentIncreasesQuery, useUpdateRentIncreaseMutation } from "../store/rent-increase.query"
type NewUnitComponentProps = {
  // lease: any;
  // open: any;
  // opened: boolean;
  // close: any;
}
export function RentIncreaseComponent(props: NewUnitComponentProps) {
  const params = useParams()
  // let { open, opened, close } = props;
  const [opened, { open, close }] = useDisclosure()
  const [userInfo, tenantInfo] = useCurrentUser()
  const [mode, setMode] = useState<"new" | "edit">("new")
  const [type, setType] = useState<"Amount" | "Percent">("Amount")
  const [selectedRentIncrease, setSelectedRentIncrease] = useState<
    string | null
  >(null)
  const [propertySearch, setPropertySearch] = useState<string | null>(null)
  const [propertiesCollection, setPropertiesCollection] =
    useState<CollectionQuery>({
      top: 10,
      skip: 0,
    })
  const [rentIncreaseCollection, setRentIncreaseCollection] =
    useState<CollectionQuery>({
      top: 10,
      skip: 0,
    })
  const [leaseCollection, setLeaseCollection] = useState<CollectionQuery>({
    top: 10,
    skip: 0,
    filter: [[{ field: "propertyId", value: params?.id as string }]],
  })
  const [createRentIncrease, createRentIncreaseResponse] =
    useCreateRentIncreaseMutation()
  const [updateRentIncrease, updateRentIncreaseResponse] =
    useUpdateRentIncreaseMutation()
  const [deleteRentIncrease, deleteRentIncreaseResponse] =
    useDeleteRentIncreaseMutation()
  // const [getProperties, properties] = useLazyGetPropertiesOfUnitQuery();
  const [getRentIncreases, rentIncreases] = useLazyGetRentIncreasesQuery()

  const defaultValue: RentIncrease = {
    //   increaseDate: null,
    increaseAmount: 0,
    increasePercentage: 0,
    reasonForIncrease: "",
    increaseDate: null,
    notifyTenant: false,
    // nextIncreaseDate: null,
    notes: "",
  }

  let schema: any = yup.object().shape({
    increaseAmount: yup.number().when([], {
      is: () => type == "Amount",
      then: (schema) =>
        schema
          .typeError(
            t("typeValidation", {
              field: t("increaseAmount"),
              type: t("number"),
            }),
          )
          .required(t("requiredValidation", { field: t("increaseAmount") })),
    }),
    increasePercentage: yup.number().when([], {
      is: () => type == "Percent",
      then: (schema) =>
        schema
          .typeError(
            t("typeValidation", {
              field: t("increasePercent"),
              type: t("number"),
            }),
          )
          .required(t("requiredValidation", { field: t("increasePercent") })),
    }),
    reasonForIncrease: yup
      .string()
      .typeError(
        t("typeValidation", {
          field: t("reasonForIncrease"),
          type: t("string"),
        }),
      )
      .required(t("requiredValidation", { field: t("reasonForIncrease") })),
    increaseDate: yup
      .date()
      .typeError(
        t("typeValidation", { field: t("increaseDate"), type: t("date") }),
      )
      .required(t("requiredValidation", { field: t("increaseDate") })),
    // increaseDate: yup.date().typeError("Increase date should be a date").required("Increase date is required"),
    notes: yup
      .string()
      .typeError(t("requiredValidation", { field: t("notes") })),
  })
  const {
    register,
    setValue,
    getValues,
    control,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
  } = useForm<RentIncrease>({
    resolver: yupResolver(schema),
    mode: "all",
  })

  useEffect(() => {
    getRentIncreases({
      ...rentIncreaseCollection,
      filter: [
        [{ field: "leaseId", value: params?.id as string, operator: "=" }],
      ],
    })
  }, [rentIncreaseCollection, getRentIncreases, params])

  // useEffect(() => {
  //     getProperties({ ...propertiesCollection, filter: [[{ field: 'name', operator: 'like', value: propertySearch as string }]] });
  // }, [propertySearch])

  // useEffect(() => {
  //     getProperties(propertiesCollection)
  // }, [propertiesCollection])

  function onSubmit(data: any) {
    try {
      data = {
        ...data,
        increaseDate: dayjs(data?.increaseDate).format(),
        leaseId: params?.id as string,
      }

      if (mode == "new") {
        createRentIncrease(data).then((response: any) => {
          // if (!response?.error) {
          reset(defaultValue)
          close()
          // }
        })
      } else {
        updateRentIncrease({
          ...data,
          id: selectedRentIncrease as string,
        }).then((response: any) => {
          // if (!response?.error) {
          reset(defaultValue)
          close()
          // }
        })
      }
    } catch (e: any) {
      console.log("🚀 ~ onSubmit ~ e:", e)
    }
  }
  const onError = (error: any) => {
    console.log("🚀 ~ onError ~ error:", error)
  }

  // function _parseProperties() {
  //     let data: { label: string; value: string }[] = [];

  //     properties?.data?.data?.map((property: Property) => {
  //         data.push({ label: property?.name as string, value: property?.id as string });
  //     })

  //     return data;
  // }

  function openUpdateModal(rentIncrease: RentIncrease) {
    open()
    setSelectedRentIncrease(rentIncrease?.id as string)
    setValue("increaseAmount", rentIncrease.increaseAmount as number)
    setValue("increasePercentage", rentIncrease.increasePercentage as number)
    setValue("reasonForIncrease", rentIncrease.reasonForIncrease as string)
    setValue("increaseDate", new Date(rentIncrease.increaseDate as Date))
    setValue("notifyTenant", rentIncrease?.notifyTenant)
    setValue(
      "nextIncreaseDate",
      new Date(rentIncrease.nextIncreaseDate as Date),
    )
    setValue("notes", rentIncrease.notes as string)
    setMode("edit")
  }

  return (
    <>
      <div className="bg-gray-800 bg-opacity-50 backdrop-filter backdrop-blur-lg shadow-lg rounded-xl p-6 border border-gray-700 mb-8">
        <LoadingOverlay
          visible={rentIncreases?.isLoading || rentIncreases?.isFetching}
        />

        <div className="flex w-full justify-end gap-2 mb-4">
          {userInfo?.role?.key !== "tenant" && (
            <Button
              variant="filled"
              loading={createRentIncreaseResponse?.isLoading}
              className={`bg-primary text-white flex space-x-2 items-center`}
              type="button"
              onClick={() => {
                open()
                reset(defaultValue)
                setMode("new")
              }}
              classNames={{ label: "flex space-x-1" }}
              size={"xs"}
            >
              <IconHomePlus size={20} strokeWidth={1.5} />{" "}
              {t("rentIncreaseAction", { action: t("add") })}
            </Button>
          )}
        </div>

        <div className="px-2 overflow-x-auto relative">
          <table className="min-w-full divide-y divide-gray-700">
            <thead
            // className="text-xs text-gray-700 capitalize bg-gray-50 dark:bg-gray-700 dark:text-gray-400 "
            >
              <tr className="text-nowrap">
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider"
                >
                  {t("baseRent")}
                </th>

                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider"
                >
                  {t("newRentAmount")}
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider"
                >
                  {t("increaseDate")}
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider"
                >
                  {t("increasePercent")}
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider"
                >
                  {t("increaseAmount")}
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider"
                >
                  {t("reasonForIncrease")}
                </th>
                {/* <th scope="col" className='px-6 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider'>
                                    Next Increase Date
                                </th> */}
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider"
                >
                  {t("status")}
                </th>

                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider"
                >
                  {t("registeredAt")}
                </th>
                {userInfo?.role?.key !== "tenant" && (
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider">
                    {t("action")}
                  </th>
                )}
              </tr>
            </thead>
            <tbody>
              {rentIncreases?.data?.data &&
                rentIncreases?.data?.data.length > 0 &&
                rentIncreases?.data?.data.map(
                  (rentIncrease: RentIncrease, idx: number) => (
                    <motion.tr
                      key={idx}
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      transition={{ duration: 0.3 }}
                      className="bg-white border-b dark:bg-gray-800 text-xs dark:border-gray-700"
                    >
                      <th className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-100 ">
                        {rentIncrease?.baseRent}
                      </th>
                      {/* <td className="py-4 px-6 text-xs">{document?.referenceNumber}</td> */}

                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-100 ">
                        {rentIncrease?.newRentAmount}
                      </td>

                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-100 ">
                        {rentIncrease?.createdAt ? (
                          <span>
                            {dateFormat(rentIncrease?.increaseDate, {
                              weekday: true,
                              day: true,
                              month: true,
                              year: true,
                              hour: false,
                            })}
                          </span>
                        ) : (
                          <span>-</span>
                        )}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-100 ">
                        {rentIncrease?.increasePercentage}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-100 ">
                        {rentIncrease?.increaseAmount}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-100 ">
                        {rentIncrease?.reasonForIncrease}
                      </td>
                      {/* <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-100 ">{
                                            rentIncrease?.createdAt ? (
                                                <span>{dateFormat(rentIncrease?.nextIncreaseDate, { weekday: true, day: true, month: true, year: true, hour: false })}</span>
                                            ) : (
                                                <span>-</span>
                                            )
                                        }</td> */}
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-100 ">
                        {rentIncrease?.status}
                      </td>

                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-100 ">
                        {rentIncrease?.createdAt ? (
                          <span>{dateFormat(rentIncrease?.createdAt)}</span>
                        ) : (
                          <span>-</span>
                        )}
                      </td>

                      {userInfo?.role?.key !== "tenant" && (
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-100 ">
                          <div className="flex space-x-2">
                            <Button
                              variant="filled"
                              // loading={removedrentIncreases.isLoading && removedrentIncreases?.originalArgs === rentIncrease?.id}
                              className={`bg-primary text-white flex space-x-2 items-center`}
                              type="button"
                              onClick={() => openUpdateModal(rentIncrease)}
                              classNames={{ label: "flex space-x-1" }}
                              size={"xs"}
                            >
                              <IconEdit size={20} strokeWidth={1.5} />
                            </Button>
                            <Confirmation
                              type={"danger"}
                              message={t("permanentDeleteMessage")}
                              onYes={() => {
                                deleteRentIncrease(rentIncrease?.id as string)
                                close()
                              }}
                              header={t("permanentDeleteTitle")}
                            >
                              <Button
                                variant="filled"
                                loading={
                                  deleteRentIncreaseResponse.isLoading &&
                                  deleteRentIncreaseResponse?.originalArgs ===
                                  rentIncrease?.id
                                }
                                className={`bg-danger text-white flex space-x-2 items-center`}
                                type="button"
                                classNames={{ label: "flex space-x-1" }}
                                size={"xs"}
                              >
                                <IconTrash size={20} strokeWidth={1.5} />
                              </Button>
                            </Confirmation>
                          </div>
                        </td>
                      )}
                    </motion.tr>
                  ),
                )}
            </tbody>
          </table>
          {!rentIncreases?.data?.data?.length ? (
            <div className="w-full relative flex justify-center items-center h-56">
              <EmptyIcon />
            </div>
          ) : (
            <></>
          )}

          {rentIncreases?.data && rentIncreases?.data?.count > 0 && (
            <div className="w-full flex justify-end items-center mt-2 mb-2">
              <Pagination
                total={rentIncreases?.data?.count as number}
                defaultPageSize={10}
                pageSize={[5, 10, 15, 20]}
                onPaginationChange={(skip: number, top: number) => {
                  setRentIncreaseCollection({
                    ...rentIncreaseCollection,
                    skip: skip,
                    top: top,
                    filter: [
                      [
                        {
                          field: "leaseId",
                          operator: "=",
                          value: params?.id as string,
                        },
                      ],
                    ],
                  })
                }}
              />
            </div>
          )}
        </div>
      </div>

      <Modal
        opened={opened}
        onClose={close}
        size={"sm"}
        title={
          mode == "new"
            ? t("rentIncreaseAction", { action: t("add") })
            : t("rentIncreaseAction", { action: t("edit") })
        }
        centered
      >
        <form onSubmit={handleSubmit(onSubmit, onError)}>
          <div className="flex w-full mt-20 space-x-4 justify-between ">
            <div className="w-full">
              <Select
                classNames={{ label: "dark:text-white" }}
                className="w-full"
                clearable
                dropdownPosition="bottom"
                label={t("increaseType")}
                placeholder={t("increaseType")}
                data={[
                  { value: "Amount", label: t("amount") },
                  { value: "Percent", label: t("percent") },
                ]}
                value={type}
                onChange={(value: "Amount" | "Percent") => setType(value)}
              />

              {type == "Amount" ? (
                <TextInput
                  classNames={{ label: "dark:text-white" }}
                  className="w-full"
                  type="number"
                  error={
                    errors.increaseAmount &&
                    `${errors?.increaseAmount?.message}`
                  }
                  withAsterisk
                  label={t("increaseAmount")}
                  placeholder={t("increaseAmount")}
                  {...register("increaseAmount")}
                />
              ) : (
                <TextInput
                  classNames={{ label: "dark:text-white" }}
                  className="w-full"
                  type="number"
                  error={
                    errors.increasePercentage &&
                    `${errors?.increasePercentage?.message}`
                  }
                  withAsterisk
                  label={t("increasePercent")}
                  placeholder={t("increasePercent")}
                  {...register("increasePercentage")}
                />
              )}

              <TextInput
                classNames={{ label: "dark:text-white" }}
                className="w-full"
                // type="number"
                error={
                  errors.reasonForIncrease &&
                  `${errors?.reasonForIncrease?.message}`
                }
                withAsterisk
                label={t("reasonForIncrease")}
                placeholder={t("reasonForIncrease")}
                {...register("reasonForIncrease")}
              />

              
              <Controller
                control={control}
                name="increaseDate"
                render={({ field }) => (
                  <DateInput
                    icon={<IconCalendar size={16} />}
                    className="w-full mt-3"
                    {...field}
                    // excludeDate={(edate) => {
                    //   if (edate.getFullYear() < date.getFullYear()) {
                    //     return true;
                    //   } else if (
                    //     edate.getFullYear() === date.getFullYear() &&
                    //     edate.getMonth() < date.getMonth()
                    //   ) {
                    //     return true;
                    //   } else {
                    //     if (
                    //       edate.getFullYear() <= date.getFullYear() &&
                    //       edate.getMonth() === date.getMonth() &&
                    //       edate.getDate() <= date.getDate()
                    //     ) {
                    //       return true;
                    //     } else {
                    //       return false;
                    //     }
                    //   }
                    // }}
                    error={
                      errors.increaseDate && `${errors.increaseDate?.message}`
                    }
                    label={t("increaseDate")}
                    withAsterisk
                  />
                )}
              />

              <div className="my-3">

                <Controller
                  control={control}
                  name="notifyTenant"
                  render={({ field }) => (
                    //@ts-ignore
                    <Switch
                      className={"my-1"}
                      checked={field.value}
                      // {...field}
                      onChange={(event: any) =>
                        field.onChange(event.currentTarget.checked)
                      }
                      label="Should we notify the tenant?"
                    />
                  )}
                />
              </div>

              <Textarea
                classNames={{ label: "dark:text-white" }}
                className="w-full"
                error={errors.notes && `${errors?.notes?.message}`}
                // withAsterisk
                label={t("notes")}
                placeholder={t("notes")}
                {...register("notes")}
              />
            </div>
          </div>

          <div className="pt-8 flex justify-end">
            <Button
              variant="filled"
              className="bg-primary text-white"
              type="submit"
              classNames={{ label: "flex space-x-1" }}
              size={"xs"}
              loading={
                createRentIncreaseResponse.isLoading ||
                updateRentIncreaseResponse.isLoading
              }
            //  onClick={() => handleAssignDriver()}
            >
              <span>
                <IconDeviceFloppy size={22} strokeWidth={1.5} />
              </span>
              {t("submit")}
            </Button>
          </div>
        </form>
      </Modal>
    </>
  )
}
